import clsx from "clsx";
import Link from "next/link";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

import styles from "./index.module.scss";

/**
 * Переключатель сортировки по популярности над выдачей (только для
 * менеджеров). Это обычная ссылка с ?sort=: выдачу собирает сервер, он же
 * запоминает выбор в куке. Остальные параметры адреса (?isManager и прочие)
 * сохраняем, номер страницы сбрасываем — порядок другой.
 */
export default function Sort() {
  const { catalogSort } = useSelector((state) => state.section);
  const router = useRouter();
  const isPopular = catalogSort === "popular";

  const [path, search] = router.asPath.split("?");
  const query = new URLSearchParams(search);
  query.delete("page");
  query.set("sort", isPopular ? "price" : "popular");

  return (
    <Link href={`${path}?${query}`} scroll={false}>
      <a
        rel="nofollow"
        data-test="catalogSortPopular"
        className={clsx(styles.Sort, isPopular && styles.On)}
      >
        <span className={styles.Switch} />
        Сортировка по популярности
      </a>
    </Link>
  );
}
